import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import InputDatePicker from 'components/pages/customer-service/action-plans/create-action-plan/InputDatePicker';
import BaseDropdownV2 from 'components/dropdowns/BaseDropdownV2';
import { getRoutes } from 'services/lorry-loading-summary/despatchSummaryService';
import Flex from 'components/common/Flex';
const LorryLoadingFilter = ({ formData, handleChange, handleSubmit }) => {
  return (
    <div className="d-flex">
      <div
        className="shadow-sm rounded-4 bg-white w-100"
        style={{ border: '1px solid #f0f0f0' }}
      >
        <Card>
          <Card.Body className="bg-light">
            <Row>
              <Col md="2">
                <InputDatePicker
                  column="deliveryDate"
                  displayName="Delivery Date"
                  selected={formData?.deliveryDate}
                  handleChange={handleChange}
                />
              </Col>
              <Col md="2">
                <Flex alignItems="center" justifyContent="between">
                  <Form.Label>Route</Form.Label>
                </Flex>
                <BaseDropdownV2
                  disabled={false}
                  fieldName={'route'}
                  closeMenuOnSelect={true}
                  isMulti={true}
                  placeholder={'Route'}
                  handleChange={handleChange}
                  getSource={getRoutes}
                  sourceParam={{ isGetAll: true }}
                  mapToOption={res => {
                    console.log(res);
                    return res?.map(i => {
                      return { ...i, value: i.id, label: i.name };
                    });
                  }}
                  value={formData?.kpiId}
                />
              </Col>
              <Col md="2">
                <Button
                  style={{ marginTop: '30px' }}
                  color="primary"
                  onClick={handleSubmit}
                >
                  Search
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};
LorryLoadingFilter.propTypes = {
  formData: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  saveConfig: PropTypes.func
};

export default LorryLoadingFilter;
